'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.diff = exports.split = undefined;

var _ace = require('./ace.js');

var _ace2 = _interopRequireDefault(_ace);

var _split = require('./split.js');

var _split2 = _interopRequireDefault(_split);

var _diff = require('./diff.js');

var _diff2 = _interopRequireDefault(_diff);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.split = _split2.default;
exports.diff = _diff2.default;
exports.default = _ace2.default;


//////////////////
// WEBPACK FOOTER
// ./~/react-ace/lib/index.js
// module id = 711
// module chunks = 0